import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterArquivoServico ] Obter arquivo servico";

export const obterArquivoServico = createAction(
  actionName,
  props<{ nomeArquivo: string}>()

);

export const obterArquivoServicoSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoServicoFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<string> }>()
);

export const obterArquivoServicoFinish = createAction(
  `${actionName} - Concluir`
);
